import { ClickoutUrl } from '@/helpers/clickout-helper';
import { useLanguageStore } from '@/helpers/composables/useStores';
import { useExperiment } from '@/libraries/experiment';
import { computed } from 'vue';

export function useDoubleStackExp() {
	const { activeVariantWithControlGroup, experimentInfo } = useExperiment('DOUBLE_STACK_EXP_3');
	const { country } = useLanguageStore();

	const hardcodedShortNameDSExp = computed(() =>
		activeVariantWithControlGroup.value && activeVariantWithControlGroup.value !== 'control' ? 'cru' : null
	);

	function isDoubleStackProvider(shortName?: string) {
		if (['FR', 'ES'].includes(country.value)) return shortName === 'prv';
		return country.value === 'DE' && shortName === 'amp';
	}

	function setDoubleStackTags(url: ClickoutUrl, placement: 'ft' | 'ro', shortName?: string) {
		if (!activeVariantWithControlGroup.value) return url;

		if (placement === 'ro' && !isDoubleStackProvider(shortName)) return url;

		const variant =
			activeVariantWithControlGroup.value === 'control'
				? 'ct'
				: activeVariantWithControlGroup.value.replace('variant_', 'v');
		const shortId = experimentInfo.value.affiliationShortId;

		const suffix = shortName === 'cru' ? '' : '-21';

		// this is a the new generic format for experiments - exp | shortName | variantShort | countryLower | placement | ...args | primeSuffix
		// once we have decided on a standard string, we can have this logic in a small composable / helper
		const tag = ['exp', shortId, variant, country.value.toLowerCase(), placement].join('-') + suffix;

		url.set('uct_ctag', tag);

		return url;
	}

	return {
		hardcodedShortNameDSExp,
		setDoubleStackTags,
		isDoubleStackProvider,
	};
}
